// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myCrownRewardsStyles } from "@rc/App/Widgets/MyCrownRewards/MyCrownRewards";
import { color } from "@rc/XDL/Utilities";
import { css } from "styled-components";

myCrownRewardsStyles.mainTitle = {
    variant: "h1",
    css: css`
        margin-bottom: 24px;
    `,
};

myCrownRewardsStyles.rewardsContainer = {
    css: css`
        display: flex;
        gap: 22px;
        flex-wrap: wrap;
    `,
};

myCrownRewardsStyles.subTitle = {
    variant: "h3",
    css: css`
        margin-bottom: 16px;
    `,
};

myCrownRewardsStyles.breakdownRewardCards = {
    css: css`
        display: flex;
        gap: 22px;
        flex-wrap: wrap;
    `,
};

myCrownRewardsStyles.rewardsDivider = {
    css: css`
        margin: 24px 0;
        border: none;
        height: 0.5px;
        background-color: ${color("common.border")};
    `,
};

myCrownRewardsStyles.centeringWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 300px;
    `,
};
